export async function captureSupportScreen(root, route) {
  if (
    ![
      "EventList",
      "EventEdit",
      "EventDetails",
      "EventAnalytics",
      "Plans",
      "CreateEvent",
    ].includes(route)
  )
    return null;
  let timer;
  try {
    return await Promise.race([
      (async () => {
        const { default: html2canvas } = await import("html2canvas");
        const canvas = await html2canvas(root.current, {
          width: window.innerWidth,
          height: window.innerHeight,
          x: window.scrollX,
          y: window.scrollY,
          scale: Math.min(
            1,
            1000 / Math.max(window.innerWidth, window.innerHeight)
          ),
          useCORS: true,
          allowTaint: false,
          logging: false,
          imageTimeout: 1200,
          ignoreElements: (el) =>
            ["IFRAME", "VIDEO"].includes(el.tagName) ||
            el.hasAttribute("data-support-private"),
          onclone: (doc) => {
            doc
              .querySelectorAll("input,textarea,[data-support-private]")
              .forEach((el) => {
                el.value = "";
                el.textContent = "";
                el.setAttribute("value", "");
              });
          },
        });
        const data = canvas.toDataURL("image/jpeg", 0.65);
        return data.length <= 1500000 ? data : null;
      })().catch(() => null),
      new Promise((resolve) => {
        timer = setTimeout(() => resolve(null), 3500);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
